/**
 * Small fixed version badge in the bottom-right corner. Shows app name,
 * trademark, semver, git short SHA, and build date so deploys can be
 * verified visually — if the SHA on screen matches the latest commit, you
 * know the new build is live (and you're not looking at a cached bundle).
 */
export function VersionBadge() {
  const version = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "0.0.0";
  const sha = typeof __BUILD_SHA__ !== "undefined" ? __BUILD_SHA__ : "dev";
  const buildTime = typeof __BUILD_TIME__ !== "undefined" ? __BUILD_TIME__ : "";

  let dateStr = "";
  try {
    if (buildTime) {
      dateStr = new Date(buildTime).toLocaleString(undefined, {
        month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
      });
    }
  } catch { /* noop */ }

  const title = `Yvree LifeScribe™ v${version} · build ${sha}${dateStr ? ` · ${dateStr}` : ""}`;

  return (
    <div
      title={title}
      className="fixed bottom-1.5 right-2.5 z-[80] pointer-events-none select-none text-[10px] tracking-[0.03em] font-semibold px-2 py-0.5 rounded-full bg-d_card/80 border border-d_border/30 text-d_text2"
    >
      Yvree LifeScribe™ v{version} · <span className="text-d_accent">{sha}</span>
      {dateStr ? <span className="text-d_text3"> · {dateStr}</span> : null}
    </div>
  );
}
